import { Controller } from "@hotwired/stimulus"

// Keeps the segmenting options mutually exclusive: checking one option ("By conversion action" /
// "By region") unchecks the others, so only one axis is ever submitted. Only one segmenting axis
// is supported at a time; the server enforces this too (see BaseController#resolve_display_options).
export default class extends Controller {
  static targets = ["option"]

  pick(event) {
    if (!event.target.checked) return
    this.optionTargets.forEach((option) => {
      if (option !== event.target) option.checked = false
    })
  }
}
